import React, { Component } from "react";
import { connect } from "react-redux";
import { debounce, flatten } from "lodash";
import Button from "../../components/Button";
import UploadButton from "../../components/UploadButton";
import {
  openModal,
  updateEditorSelectedModuleFieldValue,
  uploadEditorSelectedModuleFieldValue,
  updateEditorTranslationVariation,
  updateEditorSubjectValue,
  uploadEmailTranslations,
  clearEmailTranslations,
} from "../../actions";
import styles from "./FormatSidebar.module.css";

function fieldsToFormFields(fields) {
  if (!fields) {
    return [];
  }
  return Object.keys(fields)
    .map((key) => {
      return Object.assign({}, fields[key], {
        key,
      });
    })
    .filter((field) => {
      return field.key !== "type" && field.key !== "key";
    });
}

function presetToUpdates(preset, path) {
  if (!path) {
    path = "";
  }
  return flatten(
    Object.keys(preset)
      .filter((presetKey) => {
        return presetKey.indexOf("_") !== 0;
      })
      .map((presetKey) => {
        if (typeof preset[presetKey] === "object") {
          return presetToUpdates(preset[presetKey], path + presetKey + ".");
        }
        return {
          key: path + presetKey,
          value: preset[presetKey],
        };
      })
  );
}

export class FormatSidebar extends Component {
  constructor(props) {
    super(props);
    this.renderField = this.renderField.bind(this);
    this.renderDocumentForm = this.renderDocumentForm.bind(this);
    this.removeSelectedModule = this.removeSelectedModule.bind(this);
    this.updateEditorSelectedModuleFieldValue = debounce(
      this.updateEditorSelectedModuleFieldValue.bind(this),
      200
    );
    this.updateEditorSubjectValue = debounce(
      this.updateEditorSubjectValue.bind(this),
      200
    );
    this.applyPreset = this.applyPreset.bind(this);

    this.state = {
      drawIndex: 0,
    };
  }

  applyPreset(e) {
    const presetKey = e.currentTarget.value;
    const { fields } = this.props.module;

    if (presetKey) {
      const { presets } = fields;
      const preset = presets[presetKey];
      const updates = presetToUpdates(preset);

      updates.forEach((update) => {
        this.props.updateEditorSelectedModuleFieldValue(
          update.key,
          update.value
        );
      });

      this.setState({
        // Used to force defaultValues in inputs to update after change
        drawIndex: this.state.drawIndex + 1,
      });
    }
  }

  removeSelectedModule() {
    const { name } = this.props.module;
    this.props.openModal("confirm", {
      title: "Delete module?",
      description: "Module " + name + " will be removed from this email",
      buttons: [
        {
          label: "Delete",
          type: "primary",
          action: {
            type: "EDITOR_REMOVE_SELECTED_MODULE",
          },
        },
      ],
    });
  }

  updateEditorSelectedModuleFieldValue(fieldIndex, value) {
    this.props.updateEditorSelectedModuleFieldValue(fieldIndex, value);
  }

  updateEditorSubjectValue(fieldIndex, value) {
    this.props.updateEditorSubjectValue(fieldIndex, value);
  }

  renderField(path, field, index) {
    const { email, accountId } = this.props;
    const emailId = email.id;
    const { key, label, value, defaultValue, type, min, max, rows, options } =
      field;
    const inputValue = value || defaultValue;
    const viewLabel = label || key;
    const fieldKey = (path ? path + "." : "") + key;

    const updateField = (e) => {
      this.updateEditorSelectedModuleFieldValue(
        fieldKey,
        e.currentTarget.value
      );
    };

    const uploadField = (e) => {
      var file = e.currentTarget.files[0];
      this.props.uploadEditorSelectedModuleFieldValue(
        fieldKey,
        accountId,
        emailId,
        file
      );

      // var reader  = new FileReader();

      // reader.addEventListener('load', function () {
      //     // alert(reader.result);

      // }, false);

      // if (file) {
      //     reader.readAsDataURL(file);
      // }
    };

    // if(Array.isArray(group)) {
    if (type === "group") {
      const formFields = fieldsToFormFields(field);

      return (
        <div className={styles.fieldSet} key={index}>
          <label>{viewLabel}</label>
          <div className={styles.clear} />
          {formFields.map(
            this.renderField.bind(this, (path ? path + "." : "") + key)
          )}
        </div>
      );
    }

    if (type === "number") {
      return (
        <div className={styles.formGroup} key={index}>
          <label>{viewLabel}</label>
          <input
            name={fieldKey}
            type={type}
            min={min}
            max={max}
            defaultValue={inputValue}
            onChange={updateField}
          />
        </div>
      );
    }

    if (type === "color") {
      return (
        <div className={styles.formGroup} key={index}>
          <label>{viewLabel}</label>
          <input
            name={fieldKey}
            type="text"
            defaultValue={inputValue}
            onChange={updateField}
          />
        </div>
      );
    }

    if (type === "textarea") {
      return (
        <div className={styles.formGroup} key={index}>
          <label>{viewLabel}</label>
          <textarea
            name={fieldKey}
            defaultValue={inputValue}
            onChange={updateField}
            rows={rows || 5}
          />
        </div>
      );
    }

    if (type === "select") {
      return (
        <div className={styles.formGroup} key={index}>
          <label>{viewLabel}</label>
          <select
            name={fieldKey}
            defaultValue={inputValue}
            onChange={updateField}
          >
            {options.map((option, index) => {
              return (
                <option key={index} value={option.value}>
                  {option.label || option.value}
                </option>
              );
            })}
          </select>
        </div>
      );
    }

    if (type === "file") {
      return (
        <div className={styles.formGroup} key={index}>
          <label>{viewLabel}</label>
          <input
            name={fieldKey}
            className={styles.fieldFileText}
            type="text"
            defaultValue={inputValue}
            onChange={updateField}
          />
          <UploadButton
            className={styles.fieldFileButton}
            onChange={uploadField}
          >
            ⇧
          </UploadButton>
        </div>
      );
    }

    return (
      <div className={styles.formGroup} key={index}>
        <label>{viewLabel}</label>
        <input
          name={fieldKey}
          type={type}
          defaultValue={inputValue}
          onChange={updateField}
        />
      </div>
    );
  }

  renderDocumentForm() {
    const { email, accountId } = this.props;
    const { translations, fields } = email;

    const updateSubject = (e) => {
      this.props.updateEditorSubjectValue(e.currentTarget.value);
    };

    const uploadTranslations = (e) => {
      var file = e.currentTarget.files[0];
      this.props.uploadEmailTranslations(accountId, email.id, file);
    };

    const updateTranslationVariation = (e) => {
      this.props.updateEditorTranslationVariation(e.currentTarget.value);
    };

    const clearTranslations = (e) => {
      // this.props.clearEmailTranslations(accountId, email.id);

      this.props.openModal("confirm", {
        title: "Remove translations?",
        description: "Translations wont be removed until the document is saved",
        buttons: [
          {
            label: "Remove",
            type: "primary",
            action: {
              type: "EMAIL_CLEAR_TRANSLATIONS_SUCCESS",
            },
          },
        ],
      });
    };

    const translationPicker = translations ? (
      <div>
        <div className={styles.formGroup}>
          <label>Translations</label>
          <select onChange={updateTranslationVariation}>
            {Object.keys(translations).map((key) => {
              return (
                <option key={key} value={key}>
                  {key}
                </option>
              );
            })}
          </select>
        </div>
        <div className={styles.formGroup}>
          <label>&nbsp;</label>
          <Button onClick={clearTranslations}>Clear</Button>
        </div>
      </div>
    ) : (
      <div className={styles.formGroup}>
        <label>Translations</label>
        <UploadButton onChange={uploadTranslations}>⇧ Upload</UploadButton>
      </div>
    );

    const formFields = fieldsToFormFields(fields.data);

    return (
      <div
        key={email.id + "_" + this.state.drawIndex}
        className={styles.sidebar}
      >
        <div className={styles.moduleName}>Document</div>
        <div className={styles.formGroup}>
          <label>Subject</label>
          <textarea
            rows="4"
            defaultValue={email.subject}
            onChange={updateSubject}
          />
        </div>
        {formFields && formFields.map(this.renderField.bind(this, ""))}
        {translationPicker}
      </div>
    );
  }

  /*

            <div className={styles.formGroup}>
                <label>Brand</label>
                <select>
                    <option value="uk">Betsson</option> 
                    <option value="de">NordicBet</option> 
                </select>
            </div> 
    */

  render() {
    const { email } = this.props;

    if (!email || !email.id) {
      return <div />;
    }

    if (!this.props.module) {
      return this.renderDocumentForm();
    }

    if (this.props.module.loading) {
      return <div />;
    }

    const { name, fields } = this.props.module;
    const { selectedModule } = this.props;
    const { presets } = fields;

    const formFields = fieldsToFormFields(fields.data);

    const moduleHeader = (
      <div className={styles.moduleName}>
        {name}
        <Button color="greyed" onClick={this.removeSelectedModule}>
          x
        </Button>
      </div>
    );

    if (!formFields || formFields.length === 0) {
      return (
        <div
          key={selectedModule + "_" + this.state.drawIndex}
          className={styles.sidebar}
        >
          {moduleHeader}
          No configurable fields.
        </div>
      );
    }

    return (
      <div
        key={selectedModule + "_" + this.state.drawIndex}
        className={styles.sidebar}
      >
        {moduleHeader}
        {formFields && formFields.map(this.renderField.bind(this, ""))}

        <hr />
        {presets && (
          <div className={styles.formGroup}>
            <label>Presets</label>
            <select onChange={this.applyPreset}>
              <option value="">None</option>
              {Object.keys(presets).map((presetKey) => (
                <option key={presetKey} value={presetKey}>
                  {presets[presetKey].__label__ || presetKey}
                </option>
              ))}
            </select>
          </div>
        )}
      </div>
    );
  }
}

FormatSidebar.propTypes = {};

// Connect state data
function mapStateToProps(state) {
  const { email, selectedModule } = state.editor;
  const modules = email ? email.modules : [];
  const module = modules && modules[selectedModule];

  return {
    email,
    module,
    selectedModule,
  };
}

// Connect actions
export default connect(mapStateToProps, {
  openModal,
  updateEditorSelectedModuleFieldValue,
  uploadEditorSelectedModuleFieldValue,
  updateEditorTranslationVariation,
  updateEditorSubjectValue,
  uploadEmailTranslations,
  clearEmailTranslations,
})(FormatSidebar);
